import hatsApi from '@/services/hatsApi'

export default {
  search (params) {
    let filter = params || ''
    return hatsApi().get('/operational/person/?filter=' + JSON.stringify(filter))
  },
  getPersons () {
    return hatsApi().get('/operational/person')
  },
  getPerson (id) {
    return hatsApi().get('/operational/person/' + id)
  },
  createPerson (params) {
    return hatsApi().post('/operational/person', params)
  },
  updatePerson (params) {
    return hatsApi().put('/operational/person/' + params.id, params)
  },
  deletePerson (id) {
    return hatsApi().delete('/operational/person/' + id)
  },
  importPersons (params) {
    return hatsApi().post('/operational/person/import', params, {headers: { 'Content-Type': 'multipart/form-data' }}
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Person.js